import { render, staticRenderFns } from "./HelpDeskButton.vue?vue&type=template&id=3e4305ee"
import script from "./HelpDeskButton.vue?vue&type=script&lang=js"
export * from "./HelpDeskButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports